<template>
    <div style="text-align: center">
        <content-renderer :content="$store.getters['journey/orientation']"></content-renderer>
        <v-btn color="primary" @click="next()">{{$t('general.continue')}}</v-btn>
        <NavigationButtons :show="true"></NavigationButtons>
    </div>
</template>

<script>
    import store from '../../store'
    import {ASSESSMENT_STATE_JOURNEY_ORIENTATION} from '../../router/assessmentstate';
    import ContentRenderer from "../../components/content/ContentRenderer";
    import NavigationButtons from "../../components/framework/general/NavigationButtons";
    import applicationEventHub from "../../events/applicationEventHub";
    export default {
        name: "Orientation",
        components: {
            ContentRenderer,NavigationButtons
        },
        beforeRouteEnter(to, from, next) {
            if (!store.getters['journey/orientation']) {
                next({name: 'Journey'});
            } else {
                next();
            }
        },
      mounted(){
        applicationEventHub.frameworkButtonState(true,false);
        applicationEventHub.$on('framework.next',this.next);
        setTimeout(()=>{
          this.initiated=true;
        },800);
      },
      data(){
        return {
          hide : false,
          initiated : false,
        }
      },
        methods: {
            next() {
              this.hide=true;
              this.$nextTick(()=>{
                this.$store.dispatch('assessment/updateCurrentState', ASSESSMENT_STATE_JOURNEY_ORIENTATION);
                this.$router.replace({name: 'Journey'});
              });
            }
        },
      beforeDestroy() {
        applicationEventHub.$off('framework.next',this.next);
      }
    }
</script>

<style scoped>

</style>